import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { PageContainer } from '@toolpad/core/PageContainer';
import type React from 'react';
import { useState } from 'react';
import AssignmentDetails from '../../components/Assignments/AssignmentDetails';
import AssignmentsTable from '../../components/Assignments/AssignmentsTable';
import { useAssignments } from '../../hooks/useAssignments';
import type { Assignment } from '../../types/assignments';

const AssignmentsDashboard: React.FC = () => {
  const { assignments, loading, error } = useAssignments();
  const [selectedAssignment, setSelectedAssignment] = useState<Assignment | null>(null);

  const handleRowClick = (assignment: Assignment) => {
    setSelectedAssignment(assignment);
  };

  const handleCloseModal = () => {
    setSelectedAssignment(null);
  };

  return (
    <PageContainer title="Assignments" maxWidth={false}>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 1,
            minHeight: 200,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ flexGrow: 1 }}>
          <AssignmentsTable assignments={assignments} onRowClick={handleRowClick} />
        </Box>
      )}

      <AssignmentDetails
        open={Boolean(selectedAssignment)}
        onClose={handleCloseModal}
        assignment={selectedAssignment}
      />
    </PageContainer>
  );
};

export default AssignmentsDashboard;
